import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe, faChartBar } from '@fortawesome/free-solid-svg-icons';
import { faLinkedin, faYoutube, faXTwitter } from '@fortawesome/free-brands-svg-icons';
import banner from './assets/n3banner.png';

const App = () => {
  return (
    <div className="min-h-screen">
      {/* Banner */}
      <div className="banner-container flex items-center justify-center overflow-hidden">
        <img
          src={banner}
          alt="NGen N³ Summit — Neatco Engineering"
          className="w-full max-w-5xl h-auto block"
        />
      </div>

      {/* Content Container */}
      <div className="content-container flex flex-col pt-6 pb-12 px-4 items-center justify-center">
        {/* Title */}
        <div className="flex items-center mb-6">
          <div>
            <h1 className="text-3xl text-center font-bold text-emerald-50 sm:text-4xl">
              Thank you for scanning our QR code!
            </h1>
          </div>
        </div>

        {/* Links Column */}
        <div className="flex flex-col items-center w-full">
          <a href="https://intelview-cloud.web.app" className="button-link">
            <FontAwesomeIcon icon={faChartBar} className="mr-2" /> IntelView
          </a>
          <a href="https://www.neatcoeng.com" className="button-link">
            <FontAwesomeIcon icon={faGlobe} className="mr-2" /> Neatco
          </a>
          <a href="https://www.linkedin.com/company/42872230/" className="button-link">
            <FontAwesomeIcon icon={faLinkedin} className="mr-2 text-blue-700" /> LinkedIn
          </a>
          <a href="https://www.youtube.com/channel/UCeVTUXQMhMoxSp2MsiKuJsg" className="button-link">
            <FontAwesomeIcon icon={faYoutube} className="mr-2 text-red-600" /> YouTube
          </a>
          <a href="https://twitter.com/neatcoeng?lang=en" className="button-link">
            <FontAwesomeIcon icon={faXTwitter} className="mr-2 text-emerald-50" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default App;
